export const normalizeString = (str?: string | null): string => {
  if (!str) return "";
  return String(str)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
};

const CONTROL_CHARACTERS_REGEX = /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F]/g;
const SEARCH_SPECIAL_CHARACTERS_REGEX = /[()[\]{}<>$%&/\\|=+*#@!¿¡.,;:_"'`~^]/g;

  export  const cleanOrcid = (orcid: string) => {
            let clean = orcid.replace(/[^0-9X]/gi, '');
            
            if (!orcid.includes('https://orcid.org/')) {
                return `https://orcid.org/${clean}`;
            }
            
            return `https://orcid.org/${clean}`;
        };

export const normalizeSearchTerm = (str?: string | null): string => {
  if (!str) return "";

  return normalizeString(str)
    .replace(CONTROL_CHARACTERS_REGEX, " ")
    .replace(SEARCH_SPECIAL_CHARACTERS_REGEX, " ")
    .replace(/-{2,}/g, "-")
    .replace(/\s+/g, " ")
    .trim();
};

export const sanitizeSearchInput = (str?: string | null, maxLength: number = 500): string => {
  const normalized = normalizeSearchTerm(str);
  if (normalized.length <= maxLength) return normalized;
  return normalized.substring(0, maxLength);
};

export const matchesNormalizedSearchInFields = (
  normalizedSearchTerm: string,
  fields: Array<string | null | undefined>
): boolean => {
  if (!normalizedSearchTerm) return true;

  return fields.some((field) => normalizeSearchTerm(field).includes(normalizedSearchTerm));
};

export const matchesSearchInFields = (
  searchTerm: string | null | undefined,
  fields: Array<string | null | undefined>
): boolean => {
  return matchesNormalizedSearchInFields(normalizeSearchTerm(searchTerm), fields);
};
